var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLink(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle 12543"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 12676 (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.13398 8.9641C7.51469 6.57264 10.5726 5.75326 12.9641 7.13397C15.3556 8.51469 16.1749 11.5726 14.7942 13.9641L11.7942 19.1603C10.4135 21.5517 7.35556 22.3711 4.9641 20.9904C2.57264 19.6097 1.75326 16.5517 3.13398 14.1603L6.13398 8.9641ZM11.9641 8.86603C10.5292 8.0376 8.69445 8.52922 7.86603 9.9641L4.86603 15.1603C4.0376 16.5951 4.52922 18.4299 5.9641 19.2583C7.39898 20.0868 9.23375 19.5951 10.0622 18.1603L13.0622 12.9641C13.8906 11.5292 13.399 9.69445 11.9641 8.86603Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 12677 (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.134 4.9641C13.5147 2.57264 16.5726 1.75326 18.9641 3.13397C21.3556 4.51469 22.1749 7.57264 20.7942 9.9641L17.7942 15.1603C16.4135 17.5517 13.3556 18.3711 10.9641 16.9904C8.57264 15.6097 7.75326 12.5517 9.13398 10.1603L12.134 4.9641ZM17.9641 4.86603C16.5292 4.0376 14.6945 4.52922 13.866 5.9641L10.866 11.1603C10.0376 12.5951 10.5292 14.4299 11.9641 15.2583C13.399 16.0868 15.2338 15.5951 16.0622 14.1603L19.0622 8.9641C19.8906 7.52922 19.399 5.69445 17.9641 4.86603Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 12677 (Stroke) (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.5278 4.6141C13.1018 1.88783 16.5878 0.953745 19.3141 2.52776C22.0404 4.10177 22.9745 7.58783 21.4004 10.3141L18.4004 15.5103C16.8264 18.2365 13.3404 19.1706 10.6141 17.5966C7.88783 16.0226 6.95375 12.5365 8.52776 9.81025L11.5278 4.6141ZM17.6141 5.47224C16.514 4.83712 15.1074 5.21403 14.4722 6.3141L11.4722 11.5103C10.8371 12.6103 11.214 14.017 12.3141 14.6521C13.4142 15.2872 14.8208 14.9103 15.456 13.8103L18.456 8.6141C19.0911 7.51403 18.7142 6.10737 17.6141 5.47224ZM18.9641 3.13397C16.5726 1.75326 13.5147 2.57264 12.134 4.9641L9.13397 10.1603C7.75326 12.5517 8.57264 15.6097 10.9641 16.9904C13.3556 18.3711 16.4135 17.5517 17.7942 15.1603L20.7942 9.9641C22.1749 7.57264 21.3556 4.51469 18.9641 3.13397ZM13.866 5.9641C14.6945 4.52922 16.5292 4.0376 17.9641 4.86603C19.399 5.69445 19.8906 7.52922 19.0622 8.9641L16.0622 14.1603C15.2338 15.5951 13.399 16.0868 11.9641 15.2583C10.5292 14.4299 10.0376 12.5951 10.866 11.1603L13.866 5.9641Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLink);
export default __webpack_public_path__ + "static/media/link.767934bbf5229ee19d206679093cd70f.svg";
export { ForwardRef as ReactComponent };